import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';
import { isCharNumberValid } from './helpers/validator';
import loadable from '@loadable/component';

export const RichTextCharCounterWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "rich-text-char-counter-widget" */ 'slate-richtext-char-counter/components/Widgets/RichTextCharCounterWidget'
    ),
);

function applyConfig(config: ConfigType) {
  installSettings(config);

  // @ts-ignore
  config.widgets.widget.char_counter = RichTextCharCounterWidget;

  config.registerUtility({
    type: 'validator',
    name: 'counter',
    dependencies: {
      widget: 'char_counter',
    },
    method: isCharNumberValid,
  });

  return config;
}

export default applyConfig;
